import { Component, Input } from "@angular/core";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { loaderItems } from "../../../../../../../shared/src/lib/utils/common";

@Component({
  selector: "app-e-markets-loader",
  imports: [NgxSkeletonLoaderModule],
  templateUrl: "./e-markets-loader.component.html",
  styleUrl: "./e-markets-loader.component.scss",
})
export class EMarketsLoaderComponent {
  @Input() show: boolean | null = false;
  protected readonly loaderItems = loaderItems;
}
